import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Cross } from '@pretamanger/component-library'

export const FilterAllergensPillsContainer = styled('div')`
  ${tw`flex mb-10 `}
  ${tw`flex-col`}
  ${tw`sm:flex-row`}
`

export const WrapperFilterApplied = styled('div')`
  ${tw`flex flex-col ml-0 mt-3 sm:ml-4 sm:mt-0 sm:flex-row`}
`

export const LabelFilter = styled('p')`
  ${tw`font-bold text-[14px] leading-5 text-grey-700 mt-[7px]`}
`

export const LabelFilterApplied = styled('p')`
  ${tw`font-bold text-[14px] leading-5 text-grey-500 mr-4 mt-[7px] mb-3 sm:mb-0`}
`

export const WrapperLabel = styled('div')`
  ${tw`flex min-w-[72px] items-start`}
`

export const WrapperPills = styled('div')`
  ${tw`flex flex-wrap`}
`

export const WrapperPill = styled('div')`
  ${tw`rounded-full bg-grey-50 px-[10px] py-[6px]`}
  ${tw`flex justify-between items-center`}
  ${tw`max-h-8 border-[1px] border-grey-700`}
  ${tw`mr-2 mb-2`}
`

export const LabelPill = styled('p')`
  ${tw`font-normal text-[14px] leading-5 text-grey-700 mr-4`}
`

export const LabelClear = styled('p')`
  ${tw`font-bold text-[14px] leading-5 text-pretRed-700 ml-2`}
`

export const ButtonClear = styled('button')`
  ${tw`mt-[7px]`}
`

export const WrapperFilterMobile = styled('div')`
  ${tw`flex justify-between`}
`
